import { Eye, Paperclip, Printer, Trash2 } from "lucide-react";

const ICONS = { view: Eye, print: Printer, attach: Paperclip, delete: Trash2 };
const TONE = { delete: "text-destructive", default: "text-muted-foreground hover:text-primary" };

// أيقونات إجراءات الصف: عرض · طباعة (مستند رسمي) · مرفقات · حذف.
export const RowActions = ({ actions, testid = "row-actions" }) => (
  <div className="flex items-center justify-end gap-1" data-testid={testid}>
    {actions.map(({ key, onClick, title, badge, dot, disabled }) => {
      const Icon = ICONS[key] || Eye;
      return (
        <button
          key={key}
          type="button"
          title={title}
          disabled={disabled}
          data-testid={`${testid}-${key}`}
          onClick={(event) => {
            event.stopPropagation();
            onClick?.();
          }}
          className={`relative rounded-xl p-2 shadow-neu-sm transition-colors disabled:opacity-40 ${
            TONE[key] || TONE.default
          }`}
        >
          <Icon className="h-4 w-4" />
          {badge ? (
            <span className="num absolute -top-1 -right-1 rounded-full bg-primary px-1 text-[9px] font-bold text-primary-foreground">
              {badge}
            </span>
          ) : null}
          {dot ? (
            <span data-testid={`${testid}-${key}-dot`}
                  className="absolute -top-0.5 -right-0.5 inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-background" />
          ) : null}
        </button>
      );
    })}
  </div>
);
